import { SmartPillData } from 'owa-smart-pill';

/**
 * It filters a number of pills by its feature name
 * @param pills: Flat array of smart pills from mail stamp
 * @param pillFeatureName: The feature name of the pill
 * @param numOfPills: Number of pills required
 */
export default function filterSmartPillData(
    pills: SmartPillData[],
    pillFeatureName: string,
    numOfPills: number
): SmartPillData[] {
    return pills.filter(pill => pill.featureName === pillFeatureName).slice(0, numOfPills);
}
